import React from 'react';
import { resolveSlotComponent } from '../ComponentRegistry.jsx';
import { SpecsHeavyProductCard } from '../components/cards/SpecsHeavyProductCard.jsx';

export function ProductCardSlot({
  variant,
  product,
  tenant,
  onAddToCart,
  onViewProduct,
  onInquiry,
  compact = false,
  index = 0,
  ...props
}) {
  const requestedVariant =
    variant ||
    tenant?.settings?.product_card_variant ||
    tenant?.product_card_variant ||
    'specs_heavy';

  const CardComponent = resolveSlotComponent('card', requestedVariant) || SpecsHeavyProductCard;

  return (
    <CardComponent
      product={product}
      tenant={tenant}
      onAddToCart={onAddToCart}
      onViewProduct={onViewProduct}
      onInquiry={onInquiry}
      compact={compact}
      index={index}
      {...props}
    />
  );
}
